import React from 'react';
import { useMutation } from 'react-fetching-library';

import { Box, Button } from '@mui/material';
import { SnackbarAlert } from '../../../components-core/SnackbarAlert';

import { sendBankStatements } from '../../../services/request';


import Transactions from './Transactions';

const BankStatements = () => {
  const { mutate, error, loading } = useMutation(sendBankStatements);
  const refInputFile = React.useRef(null);
  const [transactions, setTransactions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSend = async data => {
    const { error: mutateError, payload } = await mutate(data);
    if (!mutateError) {
      setTransactions(payload.transactions);
      handleOpen();
    } else {
      setOpenSnackbar(true);
    }
  };

  const handleFileSelect = e => {
    const r = new FileReader();

    r.onload = () => {
      handleSend({ 'mt940': r.result });
      refInputFile.current.value = null;
    };

    r.readAsText(e.target.files[0], 'windows-1250');
  };

  return (
    <Box marginTop={5}>
      <Button variant="contained" component="label">
      Wczytaj plik
        <input type="file" hidden onChange={e => handleFileSelect(e)} ref={refInputFile}/>
      </Button>
      <Transactions open={open} handleClose={handleClose} transactions={transactions} setTransactions={setTransactions} />
      <SnackbarAlert open={openSnackbar} severity="error" message="Nie udało się wczytać pliku" onClose={handleCloseSnackbar} />
    </Box>
  );
};

export default BankStatements;

